import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import {
  Segment,
  Dimmer,
  Loader,
  Message,
  Header,
} from 'semantic-ui/semantic-ui-imports';
import axios from '../../services/request';
import './index.scss';

type UrlParams = {
  key: string;
};

function VerifyEmailPage() {
  const [isVerified, setIsVerified] = React.useState<boolean>(false);
  const [isError, setIsError] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const { t } = useTranslation();
  const { key } = useParams<UrlParams>();

  const verify = async () => {
    try {
      await axios.post(`/rest-auth/registration/verify-email/`, { key });
      setIsVerified(true);
      setIsLoading(false);
    } catch {
      setIsError(true);
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    verify();
  }, []);

  return (
    <div className="verify-email-page">
      <Dimmer active={isLoading}>
        <Loader active={isLoading}>{t('verifyEmailPage.loading')}</Loader>
      </Dimmer>
      <div className="verify-email-page__content">
        <Header color="teal" className="verify-email-page__content__header">
          {t('verifyEmailPage.header')}
        </Header>
        <Segment>
          {isVerified && (
            <div>
              <Message positive>
                <p>{t('verifyEmailPage.emailVerified')}</p>
              </Message>
              <Link to="/login">{t('verifyEmailPage.loginLink')}</Link>
            </div>
          )}
          {isError && (
            <div>
              <Message negative>
                <p>{t('verifyEmailPage.errorMessage')}</p>
              </Message>
              <Link to="/login">{t('verifyEmailPage.loginLink')}</Link>
            </div>
          )}
        </Segment>
      </div>
    </div>
  );
}

export default VerifyEmailPage;
